// export const colors = {
//   primaryBackground: "rgba(97, 104, 175, 1)",
//   secondaryBackground: "rgba(53, 55, 82, 1)",

//   primaryBackgroundLight: "rgba(97, 104, 175, 0.75)",
//   primaryText: "rgba(255, 176, 0, 1)",
//   secondaryText: "rgba(217, 62, 49, 1)",
//   customColor: "rgba(231, 226, 222, 1)",
// };

export const colors = {
  primary: "rgba(97, 104, 175, 1)",
  primaryDark: "rgba(53, 55, 82, 1)",
  primaryLight: "rgba(97, 104, 175, 0.75)",
  secondary: " rgba(255, 176, 0, 1)",
  secondaryDark: " rgba(255, 176, 0, 1)",
  tertiary: "#ff3920",
  tertiaryDark: "rgba(72, 59, 59, 1)",
  quaternary: "rgba(199, 199, 199, 1)",
  secondaryBackground: "rgba(56, 67, 61,1)",
  secondaryText: "#ff3920",
  customColor: "rgba(231, 226, 222, 1)",
  textColor: "#ff3920",
  closeStrokeColor: "rgba(97, 104, 175, 1)",
};
